import axios from "axios";
import { clearStoragePreservingReportColumns } from "../../utilities/reportColumnStorage";

const setupAxiosInterceptors = () => {
  // Remove any existing interceptors to avoid duplicates
  axios.interceptors.response.clear();
  
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        clearStoragePreservingReportColumns();
        window.location.href = "/";
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;